'use client';

// Hooks
import ListListing from "@src/components/templates/list-listing";

const Page = ({ pathType, mappedData, ...props }) => {
  return <ListListing pathType={pathType} mappedData={mappedData} {...props} />
}

export default Page